import { Navigate } from 'react-router';
import { useAuthStore } from '@/stores/AuthStore';

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const sessionState = useAuthStore(s => s.sessionState);

  if (sessionState === 'resolving') {
    return <div data-auth-guard="loading" style={{ display: 'none' }} />;
  }

  if (sessionState !== 'authenticated') {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
